<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/lib/store';
import { useSystemDetails } from '@/assets/modules/composables/systemDetails.js';

/**
 * Landing page for the back-office pages that used to sit in the top-level nav:
 * Support Requests, Report Entries and the Performance Report.
 *
 * The list is not written here. It travels on the "System Details" nav entry in
 * the chrome response, so the titles have one source and the Performance Report
 * link keeps the server-computed month rather than a client-side guess at it.
 * That also means a page added to the group appears here with no client change.
 */

const router = useRouter();
const { readSystemDetailsLinks } = useSystemDetails();

const links = computed(() => readSystemDetailsLinks(store.getters.getprimaryNav));

function open(url) {
    router.push({ path: url });
}
</script>

<template>
    <v-container>
        <v-row>
            <v-col>
                <h3>System Details</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                v-for="link in links"
                :key="link.url"
                cols="12"
                md="4"
            >
                <v-card variant="outlined" @click="open(link.url)">
                    <v-card-title>{{ link.title }}</v-card-title>
                    <v-card-text v-if="link.description">{{ link.description }}</v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
